query TennisTeamByTeamId (
  $teamId: UUID!
){
  team: tennisTeamByTeamId(teamId: $teamId) {
    squad
    teamId
    playerMappedForProjections: tennisTeamPlayerProjectionsMappedsByTeamId {
      nodes {
        playerId
      }
    }
  }
}
